import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FaqSection from './FAQKeyword';
import FleetHighway from './FleetHighway';
import ContactShowcase from './phoneToWhatsApp';
import TestimonialSectionKeyword from './TestimonialSectionKeyword';

function Punetosanglicab() {



  const cardData = {




keyword: "Pune to Sangli Cab",

headingDescription: "Garud Cab Service provides comfortable and reliable Pune to Sangli Cab Service for families, couples, business travelers, students, senior citizens, and groups planning a convenient journey to Sangli. Customers can book chauffeur-driven Sedan, SUV, Ertiga, Innova, Innova Crysta, Tempo Traveller, and other suitable vehicles for one-way travel, round trips, business visits, family functions, religious journeys, and customized sightseeing plans. With experienced drivers, clean and well-maintained vehicles, comfortable seating, practical luggage space, flexible pickup locations across Pune, transparent pricing, and 24/7 customer assistance, Garud Cab Service makes travel from Pune to Sangli smooth and convenient. Travelers can also customize their route to explore temples, historical landmarks, riverside attractions, and nearby destinations across the Sangli region.",

topPlaces: [
  {
    title: "Sangli Ganapati Temple",
    description: "Sangli Ganapati Temple is one of the city's important religious landmarks and is situated near the Krishna River. The temple is known for its peaceful atmosphere and attracts devotees and visitors throughout the year. Travelers from Pune can book a private cab for a comfortable journey to Sangli and conveniently include the temple in a customized sightseeing or pilgrimage itinerary."
  },
  {
    title: "Miraj",
    description: "Miraj is an important cultural and commercial city near Sangli and is particularly known for its musical heritage, healthcare facilities, and historical significance. Travelers visit the area for business, family functions, medical requirements, and cultural experiences. Garud Cab Service provides chauffeur-driven transportation from Pune with flexible pickup, drop, and return travel arrangements."
  },
  {
    title: "Audumbar",
    description: "Audumbar is a popular spiritual destination on the banks of the Krishna River and is associated with the revered saint Shri Dattatreya traditions. Devotees visit the area for religious purposes and to experience its peaceful riverside surroundings. Customers traveling from Pune can include Audumbar in their Sangli cab itinerary with comfortable private transportation."
  },
  {
    title: "Kundal",
    description: "Kundal is a historically significant destination in the Sangli region associated with ancient traditions and the local heritage of southern Maharashtra. The surrounding countryside also provides a peaceful travel experience away from busy urban areas. A private cab from Pune allows families and history enthusiasts to explore Kundal along with other nearby attractions at their own pace."
  },
  {
    title: "Chandoli",
    description: "Chandoli is a scenic destination known for forests, hills, wildlife, and the Chandoli National Park region. It is suitable for nature lovers, photographers, and travelers looking for a peaceful getaway. Garud Cab Service can arrange a comfortable private cab from Pune and customize the journey to include Chandoli and other attractions around the Sangli and western Maharashtra region."
  },
  {
    title: "Sagareshwar Wildlife Sanctuary",
    description: "Sagareshwar Wildlife Sanctuary is a unique protected area near Sangli featuring dry deciduous forests, grasslands, and diverse wildlife. The sanctuary is also associated with religious and historical attractions in the surrounding area. Travelers from Pune can plan a private road journey and include the sanctuary as part of a nature and sightseeing itinerary."
  },
  {
    title: "Kolhapur",
    description: "Kolhapur is a major cultural and religious destination located near Sangli and is known for the Mahalakshmi Temple, heritage attractions, traditional cuisine, and local markets. Travelers from Pune can combine Sangli and Kolhapur in a single private cab journey. Garud Cab Service offers flexible one-way, round-trip, and multi-destination travel options for families and groups."
  },
  {
    title: "Narsobawadi",
    description: "Narsobawadi, also known as Narsobachi Wadi, is a prominent pilgrimage destination located near the confluence of the Krishna and Panchganga rivers and is associated with Shri Dattatreya traditions. Devotees from Pune can include this destination in a religious journey toward Sangli. A private chauffeur-driven cab provides convenient transportation with flexible sightseeing and return arrangements."
  },
  {
    title: "Gaganbawda",
    description: "Gaganbawda is a scenic hill region known for lush greenery, forests, mountain views, and peaceful surroundings. It is an attractive destination for nature lovers and travelers looking for a relaxing road trip. Customers booking a Pune to Sangli cab can extend their itinerary toward Gaganbawda and explore the surrounding Western Ghats with private transportation."
  },
  {
    title: "Panhala",
    description: "Panhala is a historic hill fort destination near Kolhapur known for its connection with Maratha history, scenic mountain views, and pleasant surroundings. It is suitable for history enthusiasts, families, and weekend travelers. Garud Cab Service can include Panhala in a customized Pune to Sangli journey, providing comfortable transportation between the major destinations."
  }
],



"services": [
{
"name": "Cab from Pune to Sangli",
"description": "Book a comfortable cab from Pune to Sangli for convenient intercity travel with professional drivers, clean vehicles, and flexible pickup options. The service is suitable for families, business travelers, tourists, students, and individuals planning one-way or round-trip journeys between Pune and Sangli."
},
{
"name": "Pune to Sangli Cabs",
"description": "Choose Pune to Sangli Cabs for reliable and comfortable long-distance transportation with convenient door-to-door pickup and destination drop. Sedan, SUV, and premium cab options are suitable for family trips, business travel, personal visits, and planned outstation journeys."
},
{
"name": "Pune to Sangli Cab Booking",
"description": "Make Pune to Sangli Cab Booking for a private journey with scheduled pickup, comfortable seating, air conditioning, and professional chauffeur service. Customers can select suitable vehicles for one-way travel, return trips, family transportation, corporate journeys, and personal requirements."
},
{
"name": "Pune to Sangli Cab Service",
"description": "Book Pune to Sangli Cab Service for dependable transportation between Pune and Sangli with experienced drivers and well-maintained vehicles. The service is suitable for families, corporate passengers, tourists, and individuals looking for comfortable intercity travel with flexible pickup arrangements."
},
{
"name": "Pune to Sangli Car Rental",
"description": "Choose Pune to Sangli Car Rental for private chauffeur-driven travel with comfortable vehicles and convenient journey planning. Car rental options are suitable for business visits, family trips, sightseeing, personal travel, and long-distance transportation from Pune to Sangli."
},
{
"name": "Pune to Sangli Taxi",
"description": "Hire a Pune to Sangli Taxi for comfortable and convenient intercity transportation with a professional driver. The service provides private travel with AC vehicles, flexible pickup locations, luggage space, and options suitable for one-way, round-trip, family, and business journeys."
},
{
"name": "Sangli to Pune Cab",
"description": "Book a Sangli to Pune Cab for convenient return travel with direct pickup and destination drop. The service is suitable for passengers traveling from Sangli to Pune for business, education, medical visits, airport connections, family requirements, and personal travel."
},
{
"name": "Pune to Miraj Cab",
"description": "Choose Pune to Miraj Cab for comfortable private transportation with professional chauffeurs and well-maintained AC vehicles. The service is suitable for business travel, family visits, personal journeys, and scheduled one-way or round-trip travel between Pune and Miraj."
},
{
"name": "Miraj to Pune Cab",
"description": "Book Miraj to Pune Cab for a convenient intercity journey with comfortable seating, professional chauffeur service, and flexible pickup arrangements. The service can be used for family travel, business visits, personal transportation, and return journeys toward Pune."
},
{
"name": "Pune to Sangli Taxi Service",
"description": "Reserve Pune to Sangli Taxi Service for reliable long-distance transportation with clean AC vehicles and experienced drivers. Customers can choose suitable cab options for family trips, corporate travel, personal visits, one-way journeys, and round-trip transportation."
},
{
"name": "Pune to Sangli Outstation Cab",
"description": "Choose Pune to Sangli Outstation Cab for comfortable intercity travel with professional chauffeur service and convenient door-to-door transportation. The service is suitable for families, tourists, corporate travelers, and individuals planning one-way or return journeys."
},
{
"name": "Pune to Sangli Car Rentals",
"description": "Book Pune to Sangli Car Rentals for private and flexible transportation with comfortable vehicles and professional drivers. Rental options are suitable for business travel, family transportation, sightseeing, personal visits, and extended outstation journeys between Pune and Sangli."
},
{
"name": "Pune to Sangli Taxi Booking Online",
"description": "Make Pune to Sangli Taxi Booking Online for convenient scheduled transportation without the need for local travel to arrange a vehicle. Select a comfortable AC cab for one-way trips, round trips, family journeys, business travel, and personal transportation."
},
{
"name": "Pune to Sangli Cab Fare",
"description": "Check Pune to Sangli Cab Fare according to the selected vehicle, journey type, pickup location, and travel requirements. Sedan, SUV, and larger vehicle options can be arranged for comfortable one-way, round-trip, family, corporate, and long-distance travel."
},
{
"name": "Pune to Sangli Taxi Fare",
"description": "Plan your journey with Pune to Sangli Taxi Fare information based on vehicle category and selected travel option. Comfortable AC taxis with professional chauffeurs can be arranged for individuals, families, business travelers, and passengers requiring private intercity transportation."
},
{
"name": "Pune to Sangli Cab Price",
"description": "Get convenient Pune to Sangli Cab Price options for different vehicle categories and journey requirements. Customers can select suitable cars for one-way travel, round trips, family journeys, business transportation, sightseeing, and scheduled outstation travel."
},
{
"name": "Pune to Sangli Taxi Charges",
"description": "Choose suitable Pune to Sangli Taxi Charges based on the vehicle type and travel arrangement selected for your journey. Professional chauffeur-driven taxis provide comfortable AC transportation for families, corporate passengers, tourists, and individuals traveling between the two cities."
},
{
"name": "Best Pune to Sangli Cab Service",
"description": "Choose Best Pune to Sangli Cab Service for comfortable private transportation with professional drivers, clean vehicles, convenient pickup, and flexible journey options. The service is suitable for family trips, corporate travel, personal visits, sightseeing, and planned intercity journeys."
},
{
"name": "Cheap Pune to Sangli Cab",
"description": "Book a Cheap Pune to Sangli Cab for practical and comfortable intercity transportation with suitable vehicle options. The service is designed for passengers seeking economical travel for personal visits, family journeys, business trips, one-way transfers, and round-trip transportation."
},
{
"name": "Pune to Sangli One Way Cab",
"description": "Choose Pune to Sangli One Way Cab for direct transportation from Pune to Sangli without requiring a return journey in the same booking. Enjoy convenient pickup, comfortable AC seating, luggage space, and professional chauffeur service for personal, family, or business travel."
},
{
"name": "Pune to Sangli Round Trip Taxi",
"description": "Book Pune to Sangli Round Trip Taxi for convenient return transportation according to your planned schedule. The service is suitable for family visits, business travel, sightseeing, personal work, and short or extended trips requiring private transportation in both directions."
},
{
"name": "Pune to Sangli Innova Cab",
"description": "Choose Pune to Sangli Innova Cab for spacious and comfortable travel with a professional chauffeur. The vehicle is suitable for families, groups, business travelers, and passengers carrying additional luggage who prefer a larger AC vehicle for long-distance travel."
},
{
"name": "Pune to Sangli Innova Crysta Cab",
"description": "Book Pune to Sangli Innova Crysta Cab for premium and spacious intercity transportation with comfortable seating, AC interiors, luggage capacity, and professional chauffeur service. It is suitable for family trips, corporate travel, group journeys, and long-distance road travel."
},
{
"name": "Pune to Sangli Ertiga Cab",
"description": "Choose Pune to Sangli Ertiga Cab for practical group transportation with comfortable seating and air-conditioned interiors. The vehicle is suitable for families, small groups, business travelers, and passengers looking for a spacious option for one-way or round-trip journeys."
},
{
"name": "Pune to Sangli Sedan Cab",
"description": "Book Pune to Sangli Sedan Cab for comfortable private travel with AC interiors, convenient seating, luggage space, and professional chauffeur service. Sedan options are suitable for couples, individuals, small families, corporate passengers, and economical intercity journeys."
},
{
"name": "Pune to Sangli SUV Taxi",
"description": "Choose Pune to Sangli SUV Taxi for spacious and comfortable long-distance transportation with professional driver service. SUV options are suitable for families, groups, tourists, corporate travelers, and passengers requiring additional cabin and luggage space."
},
{
"name": "Pune to Sangli AC Cab",
"description": "Book Pune to Sangli AC Cab for comfortable travel in a clean air-conditioned vehicle with professional chauffeur service. The cab is suitable for long-distance journeys, family travel, business transportation, personal visits, and scheduled one-way or return trips."
},
{
"name": "Pune to Sangli Sedan Cab",
"description": "Choose Pune to Sangli Sedan Cab for economical and comfortable private transportation between the cities. Enjoy a clean AC vehicle, professional driver, convenient pickup, and direct destination drop suitable for families, couples, business travelers, and individuals."
},
{
"name": "Pune to Sangli Dzire Cab",
"description": "Book Pune to Sangli Dzire Cab for a practical sedan travel option with comfortable AC seating and professional chauffeur service. The vehicle is suitable for individuals, couples, small families, corporate passengers, and customers planning affordable long-distance transportation."
},
{
"name": "Pune to Sangli Etios Cab",
"description": "Choose Pune to Sangli Etios Cab for convenient intercity travel with comfortable seating, air conditioning, luggage space, and a professional driver. It is suitable for personal journeys, family travel, business visits, and one-way or round-trip transportation."
},
{
"name": "Pune to Sangli Ertiga Cab",
"description": "Reserve Pune to Sangli Ertiga Cab for spacious family and group transportation with AC interiors and professional chauffeur service. The vehicle provides a practical option for passengers carrying luggage and traveling together on long-distance journeys."
},
{
"name": "Pune to Sangli Innova Cab",
"description": "Book Pune to Sangli Innova Cab for spacious chauffeur-driven travel suitable for families and small groups. Enjoy comfortable seating, AC interiors, luggage space, and convenient pickup arrangements for one-way, round-trip, business, and personal journeys."
},
{
"name": "Pune to Sangli Innova Crysta",
"description": "Choose Pune to Sangli Innova Crysta for premium long-distance travel with spacious seating, comfortable AC interiors, luggage capacity, and professional chauffeur service. The vehicle is ideal for family trips, corporate journeys, group travel, and passengers seeking added comfort."
},
{
"name": "Pune to Sangli SUV Cab",
"description": "Hire Pune to Sangli SUV Cab for spacious and comfortable transportation with professional chauffeur service. SUV vehicles are suitable for families, groups, tourists, corporate travelers, and passengers requiring additional space for luggage during long-distance travel."
},
{
"name": "Pune to Sangli 7-Seater Cab",
"description": "Book Pune to Sangli 7-Seater Cab for comfortable group transportation with sufficient seating and luggage capacity. This option is suitable for families, friends, corporate groups, and tourists traveling together between Pune and Sangli on one-way or round-trip journeys."
},
{
"name": "Pune to Sangli Tempo Traveller",
"description": "Choose Pune to Sangli Tempo Traveller for group transportation with spacious seating and convenient luggage arrangements. It is suitable for family functions, group tours, corporate travel, pilgrimage trips, and larger groups traveling together from Pune to Sangli."
},
{
"name": "Pune to Sangli 12-Seater Traveller",
"description": "Book Pune to Sangli 12-Seater Traveller for comfortable transportation of larger families, friends, and organized groups. The vehicle provides spacious seating and practical luggage capacity for long-distance travel, group tours, corporate trips, and family journeys."
},
{
"name": "Pune to Sangli Minibus",
"description": "Choose Pune to Sangli Minibus for group travel requiring additional seating capacity and comfortable road transportation. The service is suitable for corporate groups, family functions, school or institutional travel, tour groups, and organized journeys between Pune and Sangli."
},
{
"name": "Pune to Sangli Luxury Cab",
"description": "Book Pune to Sangli Luxury Cab for a premium chauffeur-driven travel experience with comfortable interiors and spacious seating. The service is suitable for executive journeys, corporate travel, family occasions, special trips, and passengers looking for enhanced comfort on long-distance routes."
},
{
"name": "Hinjewadi to Sangli Cab",
"description": "Choose Hinjewadi to Sangli Cab for convenient intercity transportation from Pune's IT hub to Sangli. Professional chauffeurs, comfortable AC vehicles, and scheduled pickup options make the service suitable for corporate travelers, families, and individuals."
},
{
"name": "Wakad to Sangli Cab",
"description": "Book Wakad to Sangli Cab for comfortable private transportation with convenient pickup from residential and commercial areas. The service is suitable for families, professionals, tourists, and individuals planning one-way or round-trip travel to Sangli."
},
{
"name": "Baner to Sangli Cab",
"description": "Reserve Baner to Sangli Cab for direct and comfortable intercity travel with professional chauffeur service. Customers can choose suitable sedan, SUV, or larger vehicles for business travel, family journeys, personal visits, and long-distance transportation."
},
{
"name": "Aundh to Sangli Cab",
"description": "Choose Aundh to Sangli Cab for convenient door-to-door transportation with comfortable AC vehicles and experienced drivers. The service is suitable for corporate passengers, families, students, tourists, and individuals traveling from Aundh to Sangli."
},
{
"name": "Kothrud to Sangli Cab",
"description": "Book Kothrud to Sangli Cab for reliable long-distance transportation with scheduled pickup and direct destination drop. Comfortable sedan and larger vehicle options are suitable for family travel, business visits, personal journeys, and outstation transportation."
},
{
"name": "Hadapsar to Sangli Cab",
"description": "Choose Hadapsar to Sangli Cab for comfortable private transportation from eastern Pune to Sangli. The service provides convenient pickup, professional chauffeur service, AC interiors, and vehicle choices suitable for individuals, families, corporate passengers, and groups."
},
{
"name": "Kharadi to Sangli Cab",
"description": "Book Kharadi to Sangli Cab for convenient transportation from Pune's business and IT areas toward Sangli. The service is suitable for professionals, families, tourists, and individuals requiring scheduled one-way or round-trip travel with comfortable vehicles."
},
{
"name": "Viman Nagar to Sangli Cab",
"description": "Reserve Viman Nagar to Sangli Cab for comfortable intercity travel with convenient pickup from hotels, residences, offices, and nearby locations. The service is suitable for airport-connected travelers, business passengers, families, and tourists traveling toward Sangli."
},
{
"name": "Swargate to Sangli Cab",
"description": "Choose Swargate to Sangli Cab for convenient private transportation from central Pune to Sangli. Professional drivers, comfortable AC vehicles, and flexible pickup arrangements make the service suitable for family trips, business travel, personal visits, and outstation journeys."
},
{
"name": "Shivajinagar to Sangli Cab",
"description": "Book Shivajinagar to Sangli Cab for comfortable intercity travel with direct pickup and destination drop. The service is suitable for individuals, families, corporate travelers, students, and tourists looking for convenient transportation between Shivajinagar and Sangli."
},
{
"name": "PCMC to Sangli Cab",
"description": "Choose PCMC to Sangli Cab for convenient long-distance transportation from Pimpri-Chinchwad areas to Sangli. Sedan, SUV, and larger vehicle options are available for families, groups, business travelers, and individuals requiring comfortable outstation travel."
},
{
"name": "Pimpri-Chinchwad to Sangli Cab",
"description": "Book Pimpri-Chinchwad to Sangli Cab for comfortable private transportation with flexible pickup from residential, industrial, and commercial areas. Professional chauffeur service and suitable vehicle options make it convenient for family, business, and personal journeys."
},
{
"name": "Pune Railway Station to Sangli Cab",
"description": "Reserve Pune Railway Station to Sangli Cab for convenient station pickup and direct travel toward Sangli. The service is suitable for passengers arriving by train, families with luggage, business travelers, and individuals requiring a comfortable private transfer."
}
],
"tableData": [
["Cab from Pune to Sangli", "Pune to Sangli Cabs"],
["Pune to Sangli Cab Booking", "Pune to Sangli Cab Service"],
["Pune to Sangli Car Rental", "Pune to Sangli Taxi"],
["Sangli to Pune Cab", "Pune to Miraj Cab"],
["Miraj to Pune Cab", "Pune to Sangli Taxi Service"],
["Pune to Sangli Outstation Cab", "Pune to Sangli Car Rentals"],
["Pune to Sangli Taxi Booking Online", "Pune to Sangli Cab Fare"],
["Pune to Sangli Taxi Fare", "Pune to Sangli Cab Price"],
["Pune to Sangli Taxi Charges", "Best Pune to Sangli Cab Service"],
["Cheap Pune to Sangli Cab", "Pune to Sangli One Way Cab"],
["Pune to Sangli Round Trip Taxi", "Pune to Sangli Innova Cab"],
["Pune to Sangli Innova Crysta Cab", "Pune to Sangli Ertiga Cab"],
["Pune to Sangli Sedan Cab", "Pune to Sangli SUV Taxi"],
["Pune to Sangli AC Cab", "Pune to Sangli Dzire Cab"],
["Pune to Sangli Etios Cab", "Pune to Sangli SUV Cab"],
["Pune to Sangli 7-Seater Cab", "Pune to Sangli Tempo Traveller"],
["Pune to Sangli 12-Seater Traveller", "Pune to Sangli Minibus"],
["Pune to Sangli Luxury Cab", "Hinjewadi to Sangli Cab"],
["Wakad to Sangli Cab", "Baner to Sangli Cab"],
["Aundh to Sangli Cab", "Kothrud to Sangli Cab"],
["Hadapsar to Sangli Cab", "Kharadi to Sangli Cab"],
["Viman Nagar to Sangli Cab", "Swargate to Sangli Cab"],
["Shivajinagar to Sangli Cab", "PCMC to Sangli Cab"],
["Pimpri-Chinchwad to Sangli Cab", "Pune Railway Station to Sangli Cab"]
],



whychoose: [
  {
    WhyChooseheading: "Pune to Sangli Cab for a Comfortable Intercity Journey",
    WhyChoosedescription: "Garud Cab Service provides private Pune to Sangli cab transportation for families, professionals, students, couples, and groups travelling between the two cities for personal, business, educational, or family-related purposes."
  },
  {
    WhyChooseheading: "Travel Directly from Pune to Sangli",
    WhyChoosedescription: "Enjoy a dedicated cab from your preferred pickup point in Pune to your destination in Sangli without changing vehicles, offering added convenience when travelling with children, senior citizens, or luggage."
  },
  {
    WhyChooseheading: "Convenient for Family & Social Visits",
    WhyChoosedescription: "Plan private transportation for family visits, weddings, functions, social occasions, personal appointments, and other journeys where travelling together is more convenient than using multiple transport options."
  },
  {
    WhyChooseheading: "Reliable Option for Business Travel",
    WhyChoosedescription: "Professionals can use Pune to Sangli cab services for client meetings, office assignments, industrial visits, site inspections, business appointments, and other work-related journeys."
  },
  {
    WhyChooseheading: "One-Way Cab for Direct Drops",
    WhyChoosedescription: "Choose a one-way cab when you only need transportation to Sangli for relocation, personal work, education, family visits, or professional commitments without requiring the vehicle for the return trip."
  },
  {
    WhyChooseheading: "Round-Trip Booking for Return Travel",
    WhyChoosedescription: "Travellers with a scheduled return can arrange a round-trip cab according to their Sangli visit, family program, business schedule, appointment, or preferred return time."
  },
  {
    WhyChooseheading: "Vehicle Choices Based on Your Requirement",
    WhyChoosedescription: "Select a suitable vehicle according to passenger numbers, luggage, travel purpose, and preferred comfort level so your Pune to Sangli journey matches your group's transportation needs."
  },
  {
    WhyChooseheading: "Easy Journey Planning with Garud Cab Service",
    WhyChoosedescription: "Provide your Pune pickup location, Sangli destination, travel date, passenger details, luggage information, vehicle preference, and trip type to Garud Cab Service for booking assistance."
  }
]


};


const faqData = [
  {
    question: "Does Garud Cab Service provide Pune to Sangli Cab Service?",
    answer: "Yes, Garud Cab Service provides private Pune to Sangli cab services for families, professionals, students, couples, groups, and passengers travelling for personal or business requirements."
  },
  {
    question: "Can I book a one-way cab from Pune to Sangli?",
    answer: "Yes, one-way cab service can be arranged for passengers who need direct transportation from Pune to their preferred destination in Sangli."
  },
  {
    question: "Can I reserve a round-trip cab to Sangli?",
    answer: "Yes, round-trip cab arrangements can be planned according to your Sangli visit, family program, business schedule, appointment, or preferred return timing."
  },
  {
    question: "Is Pune to Sangli cab suitable for family travel?",
    answer: "Yes, private cab travel is suitable for families and groups who want to stay together and travel with convenient pickup, comfortable seating, and luggage arrangements."
  },
  {
    question: "Can I book the cab for a wedding or family function?",
    answer: "Yes, Pune to Sangli cab services can be arranged for weddings, family functions, social events, personal visits, and other planned occasions."
  },
  {
    question: "Can I use the cab for business travel in Sangli?",
    answer: "Yes, the cab can be used for client meetings, office visits, industrial work, site inspections, professional appointments, and other business-related transportation."
  },
  {
    question: "Can I book a cab for relocation from Pune to Sangli?",
    answer: "Yes, a private cab may be suitable for relocation or personal shifting requirements depending on the luggage volume and capacity of the selected vehicle."
  },
  {
    question: "Can I get pickup from my home or office in Pune?",
    answer: "Yes, pickup can be arranged from your home, hotel, office, residential society, railway station area, or another preferred location in Pune."
  },
  {
    question: "Can the cab drop me directly at my Sangli destination?",
    answer: "Yes, direct drop-off can be arranged at your home, hotel, office, residential area, business location, or another accessible destination in Sangli."
  },
  {
    question: "How can I book a Pune to Sangli Cab?",
    answer: "Share your Pune pickup location, Sangli destination, travel date, passenger details, luggage requirements, preferred vehicle, and one-way or round-trip preference with Garud Cab Service."
  }
];


const testimonials = [
  {
    id: 1,
    name: "Mr. Rohit Patil",
    feedback: "We booked a Pune to Sangli cab for a family function. Travelling together in a private vehicle was convenient, especially with children and luggage.",
    rating: 5
  },
  {
    id: 2,
    name: "Mrs. Snehal Deshmukh",
    feedback: "I arranged a round-trip cab for a Sangli visit with my family. The private travel option made it easier to manage our schedule and travel together.",
    rating: 5
  }
];



















  const Images = [
    {
      place: "/images/keyword/1.jpg",
      text: "Pune to Mumbai Airport Cab",
      link: "pune-to-mumbai-airport-cab-service",
    },
    {
      place: "/images/keyword/2.jpg",
      text: "Pune to Outstation Cabs",
      link: "Pune-to-Outstation-Cabs",
    },
    {
      place: "/images/keyword/3.jpg",
      text: "Pune to Mahabaleshwar Cab",
      link: "pune-to-mahabaleshwar-cab-service",
    },
    {
      place: "/images/keyword/4.jpg",
      text: "Pune to Lonavala Cab",
      link: "pune-to-lonavala-cab-service",
    },
    {
      place: "/images/keyword/5.jpg",
      text: "Pune to Matheran Cabs",
      link: "pune-to-matheran-cab-service",
    },
    {
      place: "/images/keyword/6.jpg",
      text: "Pune to 5 Jyotirlinga Darshan Cab",
      link: "pune-to-5-jyotirlinga-cab-service",
    },
    {
      place: "/images/keyword/7.jpg",
      text: "Pune to Bhimashankar Cab",
      link: "pune-to-bhimashankar-cab-service",
    },
    {
      place: "/images/keyword/8.jpg",
      text: "Pune to Aurangabad Cab Service",
      link: "Pune-to-Aurangabad-Cab-Service",
    },
    {
      place: "/images/keyword/9.jpg",
      text: "Pune to Nashik Cab Service",
      link: "Pune-to-Nashik-Cab-Service",
    },
    {
      place: "/images/keyword/10.jpg",
      text: "Pune to Kolhapur Cab Service",
      link: "Pune-to-Kolhapur-Cab-Service",
    },
    {
      place: "/images/keyword/11.jpg",
      text: "Pune to Alibaug Cab",
      link: "Pune-to-Alibaug-Cab",
    },
    {
      place: "/images/keyword/12.jpg",
      text: "Pune to Goa Cab Service",
      link: "Pune-to-Goa-Cab-Service",
    },
    {
      place: "/images/keyword/13.jpg",
      text: "Goa to Pune Cabs",
      link: "Goa-to-Pune-Cabs",
    },
    {
      place: "/images/keyword/14.jpg",
      text: "Innova Crysta Cab in Pune",
      link: "Innova-Crysta-Cab-in-Pune",
    },
    {
      place: "/images/keyword/15.jpg",
      text: "Ertiga On Rent in Pune",
      link: "Ertiga-On-Rent-in-Pune",
    },
    {
      place: "/images/keyword/16.jpg",
      text: "Pune to Ashtavinayak Cabs",
      link: "pune-to-ashtavinayak-cab-service",
    },
    {
      place: "/images/keyword/17.jpg",
      text: "Pune to Goa Cabs",
      link: "Pune-to-Goa-Cabs",
    },
    {
      place: "/images/keyword/18.jpg",
      text: "Pune to Jyotirlinga Darshan Package",
      link: "Pune-to-Jyotirlinga-Darshan-Package",
    },
    {
      place: "/images/keyword/19.jpg",
      text: "Pune to Akkalkot Cabs",
      link: "Pune-to-Akkalkot-Cabs",
    },
    {
      place: "/images/keyword/20.jpg",
      text: "Pune to Pandharpur Cab",
      link: "Pune-to-Pandharpur-Cab",
    },
    {
      place: "/images/keyword/21.jpg",
      text: "Pune to Grishneshwar Jyotirlinga Cab",
      link: "Pune-to-Grishneshwar-Jyotirlinga-Cab",
    },
    {
      place: "/images/keyword/22.jpg",
      text: "Pune to Mumbai Cabs",
      link: "pune-to-mumbai-cab-service",
    },
    {
      place: "/images/keyword/23.jpg",
      text: "Pune to Alibag Cab",
      link: "Pune-to-Alibag-Cab",
    },
    {
      place: "/images/keyword/24.jpg",
      text: "Pune to Goa Cab Service",
      link: "Pune-to-Goa-Cab-Service",
    },
    {
      place: "/images/keyword/25.jpg",
      text: "Innova Crysta On Rent in Pune",
      link: "Innova-Crysta-On-Rent-in-Pune",
    },

  ];




const productSchema = {
  "@context": "https://schema.org",
  "@type": "Product",
  "name": "Pune to Sangli Cab",
  "image": "https://garudcabs.com/assets/images/pune-to-sangli-cab.webp",
  "description": "Book Pune to Sangli Cab with Garud Cab for safe, comfortable, and reliable intercity travel. Get Pune to Sangli cab, taxi, and car rental services for one way trips, round trips, family journeys, business travel, and city-to-city transportation. Return travel from Sangli to Pune is also available with convenient pickup and drop options.",
  "brand": {
    "@type": "Brand",
    "name": "Garud Cab"
  },
  "aggregateRating": {
    "@type": "AggregateRating",
    "bestRating": "5",
    "worstRating": "1",
    "ratingValue": "4.8",
    "ratingCount": "7934"
  },
  "offers": {
    "@type": "Offer",
    "priceCurrency": "INR",
    "price": "Starting From ₹12/Km",
    "availability": "https://schema.org/InStock",
    "url": "https://garudcabs.com/pune-to-sangli-cab"
  }
};








  return (
    <div>

<Helmet>
  <title>Pune to Sangli Cab | Taxi, Car Rental & Booking | +91 9970007784</title>

  <meta
    name="description"
    content="Book Pune to Sangli Cab with Garud Cab for comfortable and reliable intercity travel. Get cab, taxi, car rental, and booking services for Pune to Sangli and Sangli to Pune with convenient one way and round trip options."
  />

  <meta
    name="keywords"
    content="Cab from Pune to Sangli, Pune to Sangli Cabs, Pune to Sangli Cab Booking, Pune to Sangli Cab Service, Pune to Sangli Car Rental, Pune to Sangli Taxi, Sangli to Pune Cab, Sangli to Pune Taxi"
  />

  <script type="application/ld+json">
    {JSON.stringify(productSchema)}
  </script>
</Helmet>






      <section className="page-banner">
        <div className="page-banner-container">
          <h2>
            {cardData.keyword}
          </h2>
        </div>
      </section>








      <section>
        <div className="container-fluid p-0" >
          <div className="row container-fluid px-md-2">
            <div className="col-12 col-md-7 bg-foootr">
              <img src='/images/keyword/60.jpg' alt='img' className='img-fluid' />
              <h3 className="py-1"
                style={{
                  color: '#183765', // Red color for the title 
                  textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                  fontWeight: 'bold'
                }}


              >Garud Cabs Services: {cardData.keyword} </h3><p className='fw-bold '>{cardData.headingDescription}</p>

              <div className="topPlaces">

                <p className="sectionLead">Top Places to visit from {cardData.keyword} </p>
                {cardData.topPlaces.map((place, index) => (
                  <article key={index} className="placeCard borderr" tabIndex="0">
                    <span className="placeBadge">{String(index + 1).padStart(2, "0")}</span>

                    <div className="placeBody">
                      <h4 className="placeTitle">{place.title}</h4>
                      <p className="placeDesc">{place.description}</p>

                    </div>

                    <span className="placeArrow" aria-hidden>›</span>
                  </article>
                ))}
              </div>





              <div className="services-section">
                {cardData.services.map((service, index) => (
                  <div className="service-card" key={index}>
                    <div className="service-content">
                      <h4>{service.name}</h4>
                      <span className="line"></span>
                      <p>{service.description}</p>
                    </div>

                    <div className="service-icon">
                      <i className="fas fa-arrow-right"></i>
                    </div>
                  </div>
                ))}
              </div>

              <div className="keyword-grid">
                {cardData.tableData.flat().map((keyword, index) => (
                  <div key={index} className="keyword-item">
                    <span className="keyword-bullet">-</span>
                    {keyword}
                  </div>
                ))}
              </div>



              <div id="why-choose-section" className="why-choose-section">

                <h2 className="section-title text-dark">
                  Why Choose <span>Garud Cabs Services</span>
                </h2>

                <div className="bento-grid">
                  {cardData.whychoose.map((item, index) => (
                    <div className="bento-card" key={index}>

                      <div className="bento-number">
                        {String(index + 1).padStart(2, "0")}
                      </div>

                      <h4>{item.WhyChooseheading}</h4>

                      <p>{item.WhyChoosedescription}</p>

                    </div>
                  ))}
                </div>

              </div>



              <div className="row twm-faq-section-1 m-b30">


                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                  <div className="twm-faq-info-wrap">

                    <div className="section-head left">
                      <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Garud Cabs Services </h2>
                    </div>


                    <div className="twm-faq-info">
                      <div className="accordion twm-acdn" id="sf-faq-accordion">

                        <FaqSection
                          title=""
                          subtitle=""
                          items={faqData}
                        />

                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <TestimonialSectionKeyword
                testimonials={testimonials}
              />


              <ContactShowcase keyword={cardData.keyword} />
            </div>

            <div className='col-12 col-md-4' >
              <div className="routeList">
                {Images.map((e, i) => {
                  const isExternal = typeof e.link === "string" && /^https?:\/\//i.test(e.link);
                  const href = isExternal ? e.link : `/${String(e.link || "").replace(/^\/+/, "")}`;

                  return (
                    <a
                      key={e.link || i}
                      href={href}
                      className="routeItem"
                      aria-label={e.text}
                      {...(isExternal ? { target: "_blank", rel: "noopener noreferrer" } : {})}
                    >
                      <div className="routeThumb">
                        <img src={e.place} alt="" loading="lazy" />
                      </div>

                      <div className="routeMeta">
                        <h6 className="routeTitle">{e.text}</h6>
                        <span className="routeUnderline" />
                      </div>

                      <span className="routeArrow" aria-hidden>›</span>
                    </a>
                  );
                })}
              </div>




              <div>
                <FleetHighway />
              </div>
              <div className="pc-contact">
                <h4 className="pc-title">Contact Information</h4>

                <div className="pc-grid">
                  {/* Phones */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="fas fa-phone-alt"></i>
                      <span>Phone Numbers</span>
                    </header>

                    <div className="pc-list">
                      <a href="tel:+919970007784 " className="pc-call">+91 9970007784 </a>
                    </div>
                    <div className="pc-list">
                      <a href="tel:+919970353709 " className="pc-call">+91 9970353709 </a>
                    </div>

                    <div className="pc-cta">
                      <a
                        href="https://wa.me/919970007784 "
                        target="_blank"
                        rel="noopener noreferrer"
                        className="pc-whats"
                      >
                        <i className="bi bi-whatsapp"></i> WhatsApp
                      </a>
                      <a href="tel:+919970007784 " className="pc-primary">
                        Call Now
                      </a>
                    </div>
                  </section>

                  {/* Email */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="fa-solid fa-envelope"></i>
                      <span>Email</span>
                    </header>

                    <a href="mailto:booking@garudcabs.com" className="pc-email">
                      booking@garudcabs.com
                    </a>
                  </section>

                  {/* Address */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="fa-solid fa-location-dot"></i>
                      <span>Address</span>
                    </header>

                    <address className="pc-address">
                      <strong>Garud Cabs Services</strong><br />
                      Office No.101 Anand Heights
                      Chandan Nagar, Kharadi, Pune,
                      Maharashtra, India-  411014




                    </address>
                  </section>
                </div>
              </div>


            </div>
          </div>
        </div>
      </section>


    </div>
  );
}

export default Punetosanglicab;